import React, { useEffect, useMemo } from 'react'
import { useGetAllAssistant } from '../services/usePredict'
import { useMainContext } from '../../../modules/Dashboard'

const useAssistant = () => {
    const { isLoading, isFetching, data: assistants, refetch } = useGetAllAssistant()
    const { main: { lang } } = useMainContext()
    const forexAssistants = useMemo(() => {
        let forex = []
        if (!isLoading) {
            forex = assistants?.filter(assistant => assistant.tickerCase === 'forex' && !assistant.value.startsWith('fs-'))
        }
        return forex
    }, [isLoading, assistants])


    const cryptoAssistants = useMemo(() => {
        let crypto = []
        if (!isLoading) {
            crypto = assistants?.filter(assistant => assistant.tickerCase === 'crypto' && !assistant.value.startsWith('fs-'))
        }
        return crypto
    }, [isLoading, assistants])

    useEffect(() => {
        refetch()
    }, [lang])

    return {
        loading: isLoading || isFetching,
        forexAssistants,
        cryptoAssistants,
        allAssistants: assistants
    }
}

export default useAssistant